if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p>  tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });

    $('.sym-slides').slick({
        accessibility: true,
        fade:true
    });

    $('.reviews__information').slick({
        accessibility: true,
        fade:true
    });

    $('.sym-slides-gallery').slick({
        dots:true,
        accessibility: true,
        fade:true,
        slidesToShow: 1,
    });

    $('.sym-slides-accommodations').slick({
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
    });

    $('.sym-slides-accommodations--mobile').slick({
        dots:true,
        accessibility: true,
        fade:true,
        autoplay: false,
        slidesToShow: 1,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            }
        ]
    });

    $('.awards-slider').slick({
        accessibility: true,
        arrows: true,
        slidesToShow: 2, 
        responsive: [
            {
                breakpoint: 768, 
                settings: {
                    slidesToShow: 1, 
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false
                }
            }
        ]
    });


    // ------ Script Quad Accordion --------
    var accordionItems = document.querySelectorAll('.accordion__item');
	var i;
	for (i = 0; i < accordionItems.length; i++) {
		let disItem = accordionItems[i];
		let disBtn = disItem.querySelector('.accordion__btn');
		disBtn.addEventListener('click', function () {
			disItem.classList.toggle('open');
		});
	}
    //-------End Script Accordeon ---------

})();